import { USER_ROLES } from 'constants/general';

export const NAME = 'campaignManagement-contacts';
export const REQUEST_SIZE_CAMPAIGN_MANAGEMENT = 50;

export const rolesToSubmit = [USER_ROLES.GROUP_MANAGER, USER_ROLES.SELLER, USER_ROLES.PPZ];

export const quickFilterOptions = {
	TO_BE_RELEASED: 'TO_BE_RELEASED',
	TO_BE_ASSIGNED: 'TO_BE_ASSIGNED',
};

export const quickFilterTypesSetup = [
	{
		label: 'campaignManagement:toBeReleased',
		type: quickFilterOptions.TO_BE_RELEASED,
	},
	{
		label: 'campaignManagement:toBeAssigned',
		type: quickFilterOptions.TO_BE_ASSIGNED,
	},
];

export const ROLES_WITHOUT_RESULTS = ['CENTRAL', 'GUARANTOR', 'REGION_MANAGER', 'DISTRICT_MANAGER', 'AGENCY_MANAGER'];

export const formDataFieldsMap = {
	channel: 'Kanál',
	region: 'Region',
	agency: 'Oblast',
	manager: 'Manažer',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
	contactState: 'Stav kontaktu',
	printType: 'Tisk',
	assignLevel: 'Úroveň přidělení',
	firstName: 'Jméno klienta',
	surname: 'Příjmení klienta',
	businessName: 'Název společnosti',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	municipality: 'Obec',
	zipCode: 'PSČ',
	policyNumber: 'Číslo PS',
	policyEndDate: 'Datum konce smlouvy',
	policyAgent: 'Správce PS',
	product: 'Produkt',
	quickFilterToRelease: 'K přidělení',
	quickFilterToAssign: 'K uvolnění',
};

export const quickFilterValuesMap = {
	TO_BE_RELEASED: 'quickFilterToRelease',
	TO_BE_ASSIGNED: 'quickFilterToAssign',
};
